namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;
    
    export interface IFeedbackRequest {
		name: string;
		email: string;
		type: string;
		subject: string;
		body: string;
		canContact: string;
    }

	export class FeedbackRequest implements IFeedbackRequest {
		name: string;
		email: string;
		type: string;
		subject: string;
		body: string;
		canContact: string;

		constructor(obj?: IFeedbackRequest) {
			this.name = '';
			this.email = '';
			this.type = '';
			this.subject = '';
			this.body = '';
			this.canContact = '';

            if (obj) {
				this.name = obj.name || '';
				this.email = obj.email || '';
				this.type = obj.type || '';
				this.subject = obj.subject || '';
				this.body = obj.body || '';
				this.canContact = obj.canContact || '';
            }
        }
    }
}
